import React, { memo } from "react";
import PlayerReportIframe from "./components/PlayerReportIframe";
import MetaTags from "react-meta-tags";
import { SITE_PERMISSION } from "../../common/constants/common";
import PermissionWrapper from "../../components/PermissionWrapper";
import './styles.scss';
import { useSelector } from "react-redux";
import { SITE_BRAND } from "../../constants/siteBrands";
import AgentReportIframe from "./components/AgentReportIframe";

const PlayerReport = () => {
  const { active: activeBrand } = useSelector((state) => state.Brand);
  const isWinpot = activeBrand?.siteName === SITE_BRAND.WINPOTMX;

  return (
    <div className='page-content player-report'>
      <MetaTags>
        <title>{isWinpot ? 'Agent Report' : 'Player report'} - {process.env.REACT_APP_APP_NAME}</title>
      </MetaTags>
      <PermissionWrapper
        accessPermissions={[SITE_PERMISSION.Player__Report__View]}
        withPermissionError={true}
      >
        {isWinpot ? (
          <AgentReportIframe/>
        ) : (
          <PlayerReportIframe />
        )}

      </PermissionWrapper>
    </div>
  )
}

export default memo(PlayerReport);